import { useState } from "react";
import { Avatar, Banner, Button, Cell, Group, Header, Switch } from "@vkontakte/vkui";
import type { MeResponse } from "../api/types";
import { api, errorMessage } from "../api/client";
import { formatMoney } from "../shared/format";
import { Page } from "../components/Page";
import { AccessDenied } from "../components/States";

export function ProfilePage({
  me,
  reloadMe
}: {
  me: MeResponse | null;
  reloadMe: () => Promise<void>;
}) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!me || me.user.role === "guest") {
    return (
      <Page title="Профиль">
        <AccessDenied />
      </Page>
    );
  }

  const toggleLeaderboard = async (checked: boolean) => {
    setSaving(true);
    setError("");
    try {
      await api.patch("/profile/privacy", { isVisibleInLeaderboard: checked });
      await reloadMe();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Page title="Профиль">
      {error ? <Banner header="Ошибка" subheader={error} /> : null}
      <Group header={<Header>VK-профиль</Header>}>
        <Cell before={<Avatar src={me.user.avatarUrl || undefined} />} subtitle={`VK ID ${me.user.vkUserId}`}>
          {me.user.fullName}
        </Cell>
        <Cell subtitle="Роль">{me.user.role}</Cell>
      </Group>

      <Group header={<Header>Членство</Header>}>
        {me.membership ? (
          <>
            <Cell subtitle="Уровень">{me.membership.level}</Cell>
            <Cell subtitle="Экономия">{formatMoney(me.membership.totalSaved)}</Cell>
            <Cell
              after={
                <Switch
                  checked={me.membership.isVisibleInLeaderboard}
                  disabled={saving}
                  onChange={(event) => toggleLeaderboard(event.target.checked)}
                />
              }
              subtitle="Можно отключить отображение в публичной таблице"
            >
              Показывать в рекордсменах
            </Cell>
          </>
        ) : (
          <Cell subtitle="Членская карта ещё не выдана">Гость или служебный пользователь</Cell>
        )}
      </Group>

      <Group header={<Header>Будущие улучшения</Header>}>
        <Banner
          header="Платные улучшения профиля"
          subheader="Место зарезервировано под бейджи, расширенную карточку и продвижение профиля. Платежи пока оставлены заглушкой MVP."
          actions={<Button disabled>Скоро</Button>}
        />
      </Group>
    </Page>
  );
}
